import _ from 'lodash';
const SET_ERROR = 'notifications/SET_ERROR';
const SET_WARNING = 'notifications/SET_WARNING';
const SET_INFO = 'notifications/SET_INFO';
const SET_SUCCESS = 'notifications/SET_SUCESS';
const CLEAR_ALL_NOTIFICATIONS_BY_SEVERITY = 'notifications/CLEAR_ALL_NOTIFICATIONS_BY_SEVERITY';
const CLEAR_SINGLE_NOTIFICATIONS = 'notifications/CLEAR_SINGLE_NOTIFICATIONS';
const CLEAR_ALL_NOTIFICATIONS = 'notifications/CLEAR_ALL_NOTIFICATIONS';

const initialState = {
  notifications: [],
};

export const reducer = (state = initialState, action) => {
  let notificationsLength = 0;
  if (state.notifications !== undefined) {
    notificationsLength = state.notifications.length;
  }

  switch (action.type) {
    case SET_ERROR: {
      let errorMessage = '';

      if (action.error?.response?.body?.message !== undefined) {
        errorMessage = action.error.response.body.message;
      } else if (action.error?.message !== undefined) {
        errorMessage = action.error.message;
      } else {
        errorMessage = action.error;
      }

      if (errorMessage === undefined) {
        errorMessage = action;
      }
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            message: errorMessage,
            severity: 'error',
            title: action.title !== undefined && action.title !== '' ? action.title : 'ERROR',
            key: notificationsLength + 1,
          },
        ],
      };
    }
    case SET_WARNING: {
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            message: action.notificationMessage,
            severity: 'warning',
            title: action.title !== undefined && action.title !== '' ? action.title : 'WARNING',
            key: notificationsLength + 1,
          },
        ],
      };
    }
    case SET_INFO: {
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            message: action.notificationMessage,
            severity: 'info',
            title: action.title !== undefined && action.title !== '' ? action.title : 'INFO',
            key: notificationsLength + 1,
          },
        ],
      };
    }
    case SET_SUCCESS: {
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            message: action.notificationMessage,
            severity: 'success',
            title: action.title !== undefined && action.title !== '' ? action.title : 'SUCCESS',
            key: notificationsLength + 1,
          },
        ],
      };
    }
    case CLEAR_ALL_NOTIFICATIONS: {
      return {
        ...state,
        notifications: [],
      };
    }
    case CLEAR_SINGLE_NOTIFICATIONS: {
      let currentNotifications = state.notifications;
      _.remove(currentNotifications, function (value) {
        return value.key === action.key;
      });
      return {
        ...state,
        notifications: currentNotifications,
      };
    }
    case CLEAR_ALL_NOTIFICATIONS_BY_SEVERITY: {
      let currentNotifications = state.notifications;
      _.remove(currentNotifications, function (value) {
        return value.severity === action.severity;
      });

      return {
        ...state,
        notifications: currentNotifications,
      };
    }

    default: // need this for default case
      return state;
  }
};

const Notifications = (function () {
  const setError = (error) => ({ type: SET_ERROR, error });
  const setWarning = (notificationMessage, title) => ({ type: SET_WARNING, notificationMessage, title });
  const setInfo = (notificationMessage, title) => ({ type: SET_INFO, notificationMessage, title });
  const setSuccess = (notificationMessage, title) => ({ type: SET_SUCCESS, notificationMessage, title });
  const clearAllNotificationsBySeverity = (severity) => ({ type: CLEAR_ALL_NOTIFICATIONS_BY_SEVERITY, severity });
  const clearSingleNotification = (key) => ({ type: CLEAR_SINGLE_NOTIFICATIONS, key });
  const clearAllNotification = () => ({ type: CLEAR_ALL_NOTIFICATIONS });
  const getAllNotifications = (state) => state.notifications;
  const getNotificationsLength = (state) => {
    if (state.notifications !== undefined) {
      return state.notifications.notifications.length;
    } else {
      return 0;
    }
  };
  return {
    reducer,
    clearAllNotification,
    clearSingleNotification,
    clearAllNotificationsBySeverity,
    setWarning,
    setError,
    setInfo,
    getAllNotifications,
    getNotificationsLength,
    setSuccess,
  };
})();

export default Notifications;
